import type { OutputDataOrderDtoInterface } from '@nts/std/interfaces';
import { Expose } from "@nts/std/serialization";

export class OutputDataOrderDto implements OutputDataOrderDtoInterface {

    @Expose()
    public position: number;

    @Expose()
    public propertyName: string;

    @Expose()
    public isVisible: boolean;

    @Expose()
    public caption: string;
}
